import { deriveRecoveryKeyFromPassphrase } from 'matrix-js-sdk/lib/crypto-api/key-passphrase';
import store from './store';
const getSecretStorageKey = async (opts, name) => {
    if (!store?.phrase)
        return null;
    const keyInfos = opts.keys;
    // Use MatrixClient#secretStorage and SecretStorage.ServerSideSecretStorage#getDefaultKeyId
    let keyId = await store.client.secretStorage?.getDefaultKeyId();
    let keyInfo;
    if (keyId) {
        keyInfo = keyInfos[keyId];
        if (!keyInfo) {
            keyId = null;
        }
    }
    if (!keyId) {
        // if no default SSSS key is set, fall back to a heuristic of using the
        // only available key, if only one key is set
        const keyInfoEntries = Object.entries(keyInfos);
        if (keyInfoEntries.length > 1) {
            throw new Error('Multiple storage key requests not implemented');
        }
        [keyId, keyInfo] = keyInfoEntries[0];
    }
    if (!keyInfo)
        return null;
    // If the SSSS key was set up with a recovery key (not a passphrase),
    // keyInfo.passphrase will be undefined. We cannot derive a key from a
    // passphrase in that case — return null to signal that the callback
    // cannot provide the key (rather than crashing with a TypeError).
    if (!keyInfo.passphrase)
        return null;
    const derivedKey = await deriveRecoveryKeyFromPassphrase(store.phrase, keyInfo.passphrase.salt, keyInfo.passphrase.iterations);
    // Do NOT clear store.phrase here — the SDK may call this callback
    // multiple times during a single operation (bootstrapCrossSigning,
    // bootstrapSecretStorage, etc.).  The caller is responsible for
    // clearing store.phrase when the high-level operation completes.
    return [keyId, derivedKey];
};
export default getSecretStorageKey;
